<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير كشف حصر التضامن"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[
        name,
        desc,
        `تقرير كشف حصر التضامن  من شهر ${convert_Month(
          from
        )} الى شهر ${convert_Month(to)}`,
      ]"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  async mounted() {
    if (this.globalCompanyInfo) {
      await this.getCompanyInfo();
    }
  },
  props: [
    "from",
    "to",
    "date",
    "name",
    "desc",
    "FilterDeparmentClassificationsIds",
    "bankClassificationId",
  ],
  data() {
    return {
      json_fields: {
        الإسم: "employeeName",
        "الدخل الإجمالى": "netSalary",
        "حصة التأمين 1 %": "solidarityTax",
      },
      headerArray: [
        `تقرير كشف حصر التضامن  من شهر ${this.start} الى شهر ${this.to}`,
      ],
    };
  },
  watch: {
    globalCompanyInfo(newValue) {
      this.getCompanyInfo();
    },
  },
  methods: {
    async getCompanyInfo() {
      this.headerArray.unshift(this.globalCompanyInfo.shortName);
      this.headerArray.unshift(this.globalCompanyInfo.fullName);
    },
    async fetchData() {
      if (this.from == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال من تاريخ الشهر"
        );
      }
      if (this.to == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال الى تاريخ الشهر"
        );
      }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);

      let schema = {
        From: this.from,
        To: this.to,
        BankClassificationId: this.bankClassificationId,
        FilterDeparmentClassificationsIds:
          this.FilterDeparmentClassificationsIds == ""
            ? null
            : this.FilterDeparmentClassificationsIds,
      };
      let result = await axios.patch(
        `${env.HR()}/api/SalariesReports/SocialSolidarity`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      // console.warn(result);
      return result.data.data.socialSolidarities;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
  },
  computed: {
    globalCompanyInfo() {
      return this.$store.getters["global/companyInfo"];
    },
    start() {
      return this.from;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>